import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';

/**
 * Props type for the ReactionConsumer class component
 */

/**
 * State type for the ReactionConsumer class component
 */

/**
 * A custom mapper class that takes the store instance and mapper functions "mapStateToProps" and "mapActionsToProps" to return the renderProps pattern as a child component
 * @deprecated please avoid using this class as it will be removed in a future release
 */
export var ReactionConsumer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ReactionConsumer, _React$PureComponent);
  var _super = _createSuper(ReactionConsumer);
  function ReactionConsumer(props) {
    var _this;
    _classCallCheck(this, ReactionConsumer);
    _this = _super.call(this, props);
    /**
     * Get the actions the child component might need to dispatch from its props
     */
    _defineProperty(_assertThisInitialized(_this), "getPropsFromActions", function (actions) {
      var mapActionsToProps = _this.props.mapActionsToProps;
      if (mapActionsToProps) {
        if (!_this.previousActions || !_this.propsFromActions || _this.previousActions !== actions) {
          _this.propsFromActions = mapActionsToProps(actions);
        }
      }
      _this.previousActions = actions;
      return _this.propsFromActions;
    });
    /**
     *
     * @param state Internal state data
     * @returns object containing the data that the connected component needs
     */
    _defineProperty(_assertThisInitialized(_this), "getPropsFromState", function (state) {
      var mapStateToProps = _this.props.mapStateToProps;
      return mapStateToProps ? mapStateToProps(state) : undefined;
    });
    /**
     *
     */
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function () {
      _this.forceUpdate();
    });
    _this.state = {
      store: undefined
    };
    return _this;
  }
  _createClass(ReactionConsumer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      Promise.resolve(this.props.store).then(function (store) {
        _this2.setState({
          store: store
        });
        store.onChange(_this2.handleOnChange);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.state.store) {
                this.state.store.removeOnChangeListener(this.handleOnChange);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }
      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.store) {
        return null;
      }
      return this.props.children(Object.assign({}, this.getPropsFromState(this.state.store.getState()), this.getPropsFromActions(this.state.store)));
    }
  }]);
  return ReactionConsumer;
}(React.PureComponent);